import {ScrollView} from '@genestack/ui';
import classNames from 'classnames';
import React from 'react';

import styles from './dsl-view.module.css';
import {DSLPreloader} from '../../../../../preloader/dsl-preloader';

interface Props {
    element: HTMLElement | undefined;
}

export const DSLView = ({element}: Props) => {
    const containerRef = React.useCallback(
        (node: HTMLDivElement | null) => {
            if (node && element) {
                node.appendChild(element);
            }
        },
        [element]
    );

    return (
        <DSLPreloader show={!element}>
            {element && (
                <ScrollView className={styles.root}>
                    <div ref={containerRef} className={classNames(styles.dsl)} />
                </ScrollView>
            )}
        </DSLPreloader>
    );
};
